import React from "react"

import styled from "styled-components"

import { spacing } from "@izettle/otto"

import { SvgIcon } from "../../svg-icon"

export const SvgIconStyled = React.memo(styled(SvgIcon)`
  margin-top: ${spacing.medium};
`)
